import { render, staticRenderFns } from "./GoodsPromotionCfgPane.vue?vue&type=template&id=97f1af26&scoped=true"
import script from "./GoodsPromotionCfgPane.vue?vue&type=script&lang=js"
export * from "./GoodsPromotionCfgPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f1af26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97f1af26')) {
      api.createRecord('97f1af26', component.options)
    } else {
      api.reload('97f1af26', component.options)
    }
    module.hot.accept("./GoodsPromotionCfgPane.vue?vue&type=template&id=97f1af26&scoped=true", function () {
      api.rerender('97f1af26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/goods_promotion/GoodsPromotionCfgPane.vue"
export default component.exports